export default __webpack_public_path__ + "static/frame_built-1d7f0e93cc10816c27d9a0e53eac7e6b.jpg";